seedWebApp.controller('QuoteErrorController', ['$scope', '$rootScope', '$window', '$route', 'ContactService', 'StoreService', 'ToastService',
    function ($scope, $rootScope, $window, $route, ContactService, StoreService, ToastService) {
        console.log('quoteErrorController');

    }
]);